import React, { useState } from 'react';
import { Drawer, Button, List, Avatar, Badge, Space, Typography, Divider, Empty, notification } from 'antd';
import { BellOutlined, ClearOutlined, ReloadOutlined, CheckCircleOutlined, ExclamationCircleOutlined, InfoCircleOutlined } from '@ant-design/icons';

const { Text, Title } = Typography;

const NotificationDrawer = ({ open, onClose, showDrawer }) => {

    const [notifications, setNotifications] = useState([
        // {
        //     id: 1,
        //     type: 'info',
        //     title: 'Task Assignment',
        //     message: 'You have been assigned to Review Customer Feedback',
        //     timestamp: '2 minutes ago',
        //     read: false,
        //     avatar: 'https://xsgames.co/randomusers/avatar.php?g=pixel&key=1'
        // },
        // {
        //     id: 2,
        //     type: 'warning',
        //     title: 'Deadline Reminder',
        //     message: 'Project milestone due in 2 hours',
        //     timestamp: '5 minutes ago',
        //     read: false,
        //     avatar: 'https://xsgames.co/randomusers/avatar.php?g=pixel&key=2'
        // },
        // {
        //     id: 3,
        //     type: 'success',
        //     title: 'Task Completed',
        //     message: 'Database backup completed successfully',
        //     timestamp: '1 hour ago',
        //     read: true,
        //     avatar: 'https://xsgames.co/randomusers/avatar.php?g=pixel&key=3'
        // },
        // {
        //     id: 4,
        //     type: 'error',
        //     title: 'System Alert',
        //     message: 'Server response time exceeded threshold',
        //     timestamp: '2 hours ago',
        //     read: false,
        //     avatar: 'https://xsgames.co/randomusers/avatar.php?g=pixel&key=4'
        // }
    ]);

    const unreadCount = notifications.filter(n => !n.read).length;



    const clearAllNotifications = () => {
        setNotifications([]);
        notification.success({
            message: 'Notifications Cleared',
            description: 'All notifications have been cleared successfully.',
            placement: 'topRight',
        });
    };

    const refreshNotifications = () => {
        // Simulate fetching new notifications
        notification.info({
            message: 'Refreshing',
            description: 'Checking for new notifications...',
            placement: 'topRight',
        });

        // Add a new notification after a short delay
        setTimeout(() => {
            const newNotification = {
                id: Date.now(),
                type: 'info',
                title: 'New Update',
                message: 'System refresh completed',
                timestamp: 'Just now',
                read: false,
                avatar: 'https://xsgames.co/randomusers/avatar.php?g=pixel&key=5'
            };
            setNotifications(prev => [newNotification, ...prev]);
        }, 1000);
    };

    const markAsRead = (id) => {
        setNotifications(prev =>
            prev.map(notification =>
                notification.id === id ? { ...notification, read: true } : notification
            )
        );
    };

    const getIconByType = (type) => {
        switch (type) {
            case 'success':
                return <CheckCircleOutlined style={{ color: '#52c41a' }} />;
            case 'warning':
                return <ExclamationCircleOutlined style={{ color: '#faad14' }} />;
            case 'error':
                return <ExclamationCircleOutlined style={{ color: '#ff4d4f' }} />;
            default:
                return <InfoCircleOutlined style={{ color: '#1890ff' }} />;
        }
    };

    return (
        <>
            
            <Drawer
                title={
                    <Space>
                        <BellOutlined />
                        <span>Notifications</span>
                        {unreadCount > 0 && (
                            <Badge count={unreadCount} size="small" />
                        )}
                    </Space>
                }
                placement="left"
                onClose={onClose}
                zIndex={2019}
                open={open}
                width={400}
                extra={
                    <Space>
                        <Button
                            type="text"
                            icon={<ReloadOutlined />}
                            onClick={refreshNotifications}
                            title="Refresh"
                        />
                        <Button
                            type="text"
                            icon={<ClearOutlined />}
                            onClick={clearAllNotifications}
                            title="Clear All"
                            disabled={notifications.length === 0}
                        />
                    </Space>
                }
            >
                {notifications.length === 0 ? (
                    <Empty
                        description="No notifications"
                        style={{ marginTop: 100 }}
                    />
                ) : (
                    <List
                        itemLayout="horizontal"
                        dataSource={notifications}
                        renderItem={(item) => (
                            <List.Item
                                style={{
                                    backgroundColor: item.read ? 'transparent' : '#f0f8ff',
                                    padding: '12px',
                                    margin: '8px 0',
                                    borderRadius: '6px',
                                    border: item.read ? '1px solid #f0f0f0' : '1px solid #d9d9d9',
                                    cursor: 'pointer'
                                }}
                                onClick={() => markAsRead(item.id)}
                            >
                                <List.Item.Meta
                                    avatar={
                                        <Badge dot={!item.read}>
                                            <Avatar src={item.avatar} />
                                        </Badge>
                                    }
                                    title={
                                        <Space>
                                            {getIconByType(item.type)}
                                            <Text strong={!item.read}>{item.title}</Text>
                                        </Space>
                                    }
                                    description={
                                        <div>
                                            <Text type="secondary">{item.message}</Text>
                                            <br />
                                            <Text type="secondary" style={{ fontSize: '12px' }}>
                                                {item.timestamp}
                                            </Text>
                                        </div>
                                    }
                                />
                            </List.Item>
                        )}
                    />
                )}

                <Divider />

                <div style={{ textAlign: 'center', padding: '16px' }}>
                    <Space direction="vertical">
                        <Button type="link" size="small">
                            View All Notifications
                        </Button>
                        <Button type="link" size="small">
                            Notification Settings
                        </Button>
                    </Space>
                </div>
            </Drawer>
        </>
    );
};

export default NotificationDrawer;